export type WritingAssistantState = 'idle' | 'loading' | 'result' | 'tips' | 'error';

/**
 * Why a rewrite cannot be accepted, absent when it can. The two cases need different advice: one
 * asks the coordinator to rewrite their own text, the other to ask the model for a shorter answer.
 */
export type RewriteRejection = 'notAnEventDescription' | 'tooLongForField';

export const MIN_AI_DESCRIPTION_LENGTH = 100;
